import { render, staticRenderFns } from "./cellNew.vue?vue&type=template&id=d2f5269c&scoped=true&"
import script from "./cellNew.vue?vue&type=script&lang=js&"
export * from "./cellNew.vue?vue&type=script&lang=js&"
import style0 from "./cellNew.vue?vue&type=style&index=0&id=d2f5269c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f5269c",
  null
  
)

export default component.exports